<template>
    <component :is="template">
        <v-container>
            <v-row>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <div class="tit-wrap tit-wrap--unberline">
                                <v-row align="center">
                                    <v-col cols="12" md="">
                                        <h2 class="tit">상품권 교환소</h2>
                                    </v-col>
                                    <v-col cols="12" md="auto">
                                        <v-text-field v-model="searchValue" name="searchValue" type="search" autocomplete="off" hide-details outlined placeholder="상품권 검색" class="w-100 w-md-260px" @keydown.enter="()=>$router.push(`brand/giftcards/search?search=${searchValue}`)">
                                            <template v-slot:append>
                                                <v-icon v-show="searchValue" size="28" class="mr-1" @click="searchValue = null">mdi-close</v-icon>
                                                <v-icon size="28" @click="()=>$router.push(`brand/giftcards/search?search=${searchValue}`)">mdi-magnify</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="font-size-14 font-size-md-16 grey--text text--garken-3 mt-md-n20px mb-20px mb-md-22px">
                                <p>* 교환소 내 모든 상품은 나누리 캐시로 교환 할 수 있는 상품입니다. 캐시 외에 구입 불가 합니다.</p>
                                <p>* 본인인증을 진행한 후 30분 동안 구매 가능합니다.</p>
                                <p>* 구매전 본인인증을 진행해주세요</p>
                            </div>

                            <!-- 상품권 카테고리 -->
                            <giftcard-navi :categories="categories" @setCategory="setCategory"/>

                            <!-- 상품권 리스트 -->
                            <giftcard-list-2 :brands="brands" />

                            <div class="mt-30px mt-md-70px">
                                <v-pagination v-model="page" :length="pageCount"  color="primary" total-visible="11" @input="search()" />
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-dialog v-if="!me?.ci && meLoaded" v-model="dialog" max-width="500" :width="$vuetify.breakpoint ? '50%' : '90%' " scrollable>
                <v-card>
                    <a href="/mypage/profile"><v-img src="/images/giftcard-popup3.jpg"/></a>
                    <div class="popup-layer-foot" style="display: flex; background-color: #424242; padding: 10px;">
                        <v-spacer></v-spacer>
                        <v-btn text @click="close" style="color:white; font-size: 16px;">닫기</v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </v-container>
        <popup-layer code="gshop"/>
    </component>
</template>
<script>
import api from '@/api'
import giftcardNavi from "@/components/client/gshop/giftcard/giftcard-navi.vue";
import giftcardList2 from "@/components/client/gshop/giftcard/giftcard-list2.vue";
import PopupLayer from '@/components/client/popup/popup-layer.vue';

export default {
    components: {
        giftcardNavi,
        giftcardList2,
        PopupLayer
    },
    data() {
        return {
            categories: [],
            brands: null,
            me: null,
            searchValue : null,

            meLoaded: false,

            page: Number(this.$route.query.page) || 1,
            limit: 30,
            pageCount: 0,

            dialog: true,

            filter: {
                _category: this.$route.query._category || null
            }
        };
    },
    async mounted() {
        this.dialog = !this.$cookies.get('dialog');
        await this.init();
    },
    created(){
        if(this.logoff) this.$router.push(`/login`);
    },
    methods: {
        async init() {
            let [ { me }, { categories } ] = await Promise.all([
                api.v1.me.profile.get(),
                api.v1.gshop.categories.gets({ headers: { limit: 0 }, params: { depth: 0 } })
            ])
            this.me = me;
            this.meLoaded = true;
            this.categories = categories;
            await this.search()
        },
        async search(routable = false){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });

            let { summary, brands } = await api.v1.gshop.brands.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: { ...this.filter }
            });
            
            this.brands = brands;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async setCategory(category) {
            console.log("sss");
            this.$router.push({
                query: { ...this.filter, page: 1, _category: category?._id }
            })
            this.filter._category = category?._id
            this.page = 1
            await this.search()
        },
        close(){
            this.dialog = false
        }
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        accessToken(){
            return this.$store.state.accessToken;
        },
        logoff(){
            return !this.$store.state.accessToken;
        },
    },
    watch: {
        dialog(){
            if(!this.me.ci && !this.dialog){
                this.$router.push('/mypage/profile')
            }
        },
        async '$route.query._category'(){
            console.log("ss");
            this.filter._category = this.$route.query._category;
            this.page = 1
            await this.search()
        },
        async "$route.query.page"() {
            if(this.$route.query.page === "1") {
                this.page = 1
                await this.search();
            }
        },
        dialog(){
            if(!this.me.ci && !this.dialog){
                this.$router.push('/mypage/profile')
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
    .contents-area {
        padding: 60px 114px;
    }
}
</style>
